import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import Dropdown from "../../../modules/Dropdown";
import React, { useCallback, useMemo, useState } from "react";
import getClassNameFactory from "../../../utilities/classNames";
import { CountryFilter } from "./CountryFilter";
import { CountrySelectorHeader } from "./CountrySelectorHeader";
import { getCountryOptionLabel } from "../PhoneNumberInputUtilities";
import DropdownContent from "../../Dropdown/components/DropdownContent";
export var CountrySelector = function CountrySelector(_ref) {
  var dropdownMaxVisibleItems = _ref.dropdownMaxVisibleItems,
      dropdownContentMaxWidth = _ref.dropdownContentMaxWidth,
      dropdownPlaceholder = _ref.dropdownPlaceholder,
      filterCloseLabel = _ref.filterCloseLabel,
      filterPlaceholder = _ref.filterPlaceholder,
      filterNothingFoundWarning = _ref.filterNothingFoundWarning,
      headerAriaLabel = _ref.headerAriaLabel,
      headerIconLabel = _ref.headerIconLabel,
      CountryIcon = _ref.iconComponent,
      onChange = _ref.onChange,
      rawOptions = _ref.options,
      selectedCountry = _ref.value;
  var getClassName = getClassNameFactory(CountrySelector.displayName);

  var _useState = useState(""),
      _useState2 = _slicedToArray(_useState, 2),
      filterValue = _useState2[0],
      setFilterValue = _useState2[1];

  var filteredOptions = useMemo(function () {
    return rawOptions.map(function (_ref2) {
      var label = _ref2.label,
          value = _ref2.value;
      return {
        label: getCountryOptionLabel(label, value),
        value: value
      };
    }).filter(function (_ref3) {
      var label = _ref3.label;
      return label.toLowerCase().startsWith(filterValue.toLowerCase());
    });
  }, [filterValue, rawOptions]);
  var isEmptyOptionsList = filteredOptions.length === 0;
  var handleChange = useCallback(function (value) {
    return onChange(value);
  }, [onChange]);

  var dropdownCollapseHandler = function dropdownCollapseHandler(handler) {
    setFilterValue("");
    handler();
  };

  var renderFilter = useCallback(function (dropdownCollapse, containerRef, inputId) {
    return /*#__PURE__*/React.createElement(CountryFilter, {
      closeLabel: filterCloseLabel,
      inputId: inputId,
      ref: containerRef,
      nothingFoundWarning: isEmptyOptionsList && filterNothingFoundWarning,
      onClose: dropdownCollapse,
      placeholder: filterPlaceholder,
      setValue: setFilterValue,
      value: filterValue
    });
  }, [filterPlaceholder, filterValue, isEmptyOptionsList]);
  var renderHeader = useCallback( // eslint-disable-next-line max-params
  function (text, isExpanded, toggleExpand, expandButtonId) {
    return /*#__PURE__*/React.createElement(CountrySelectorHeader, {
      ariaLabel: headerAriaLabel,
      expandButtonId: expandButtonId,
      icon: /*#__PURE__*/React.createElement(CountryIcon, {
        country: selectedCountry,
        label: headerIconLabel
      }),
      isExpanded: isExpanded,
      toggleExpand: function (_toggleExpand) {
        function toggleExpand() {
          return _toggleExpand.apply(this, arguments);
        }

        toggleExpand.toString = function () {
          return _toggleExpand.toString();
        };

        return toggleExpand;
      }(function () {
        return dropdownCollapseHandler(toggleExpand);
      })
    });
  }, [CountryIcon, headerIconLabel, selectedCountry]);

  var renderContent = function renderContent(props) {
    return /*#__PURE__*/React.createElement(DropdownContent, _extends({}, props, {
      maxWidth: dropdownContentMaxWidth
    }));
  };

  return /*#__PURE__*/React.createElement(Dropdown, {
    className: getClassName({
      modifiers: isEmptyOptionsList && "nothingFound"
    }),
    items: filteredOptions,
    key: selectedCountry,
    maxVisibleItems: dropdownMaxVisibleItems,
    onValueChanged: handleChange,
    placeholder: dropdownPlaceholder,
    renderContent: renderContent,
    renderFilter: renderFilter,
    renderHeader: renderHeader,
    value: selectedCountry,
    withCheckmark: true
  });
};
CountrySelector.displayName = "CountrySelector";